export const FETCHING_ADJUSTMENT_DETAIL = 'FETCHING_ADJUSTMENT_DETAIL';
export const SELECTED_ADJUSTMENT_DETAIL = 'SELECTED_ADJUSTMENT_DETAIL';
export const CREATE_EDIT_ADJUSTMENT_ITEMS = 'CREATE_EDIT_ADJUSTMENT_ITEMS';
export const FETCHING_ADJUSTMENT_DETAIL_ERROR =
  'FETCHING_ADJUSTMENT_DETAIL_ERROR';
export const ADJUSTMENT_LOADING = 'ADJUSTMENT_LOADING';
export const ADJUSTMENT_DETAIL_SUBMIT = 'ADJUSTMENT_DETAIL_SUBMIT';
export const SUBMIT_ADJUSTMENT_DETAIL_ERROR = 'SUBMIT_ADJUSTMENT_DETAIL_ERROR';
export const SUBMITTING_ADJUSTMENT_DETAIL = 'SUBMITTING_ADJUSTMENT_DETAIL';
export const CLEAR_ADJUSTMENT_ERROR_SUCCESS = 'CLEAR_ADJUSTMENT_ERROR_SUCCESS';
export const ADJUSTMENT_ITEMS_LOADING_ERROR = 'ADJUSTMENT_ITEMS_LOADING_ERROR';
export const RE_ADJUSTMENT_ITEM_LIST = 'RE_ADJUSTMENT_ITEM_LIST';
export const VIEW_ADJUSTMENT_ITEMS = 'VIEW_ADJUSTMENT_ITEMS';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/createEditAdjustment/types.js